export default __webpack_public_path__ + "static/media/pt-serif-v12-latin-regular.fa3d4384.eot";